import React from "react";
import AccordionTwoColumnGrid from "@/components/molecules/AccordionTwoColumnGrid";
import { useTranslation } from "react-i18next";
import Stack from "@/components/atoms/Stack";
import Text from "@/components/atoms/Text";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import { Grid } from "@mantine/core";
import { Control, Controller } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import Select, { transformDataToSelectOption } from "@/components/atoms/Select";

interface TransportResponsibleProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const options = [
  {
    value: false,
    label: "yes",
  },
  {
    value: true,
    label: "no",
  },
];
const TransportResponsible: React.FC<TransportResponsibleProps> = ({ control, saveDraft }) => {
  const { t } = useTranslation();

  const leftContent = (
    <Stack>
      <Text size="lg" display="technical" tt="uppercase" fw={500} ff="heading" mt={20}>
        {t("registerCompany:transport.title")}
      </Text>
      <Grid>
        <Grid.Col span={1} pr={0} mr={0}>
          <SVGAsset name="circle-questionmark" />
        </Grid.Col>
        <Grid.Col span={10} pl={0} ml={0}>
          <Text size="sm" color="secondary">
            {t("registerCompany:transport.reason")}
          </Text>
        </Grid.Col>
      </Grid>
    </Stack>
  );

  const rightContent = (
    <Grid>
      <Grid.Col span={12} />
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Controller
          name="partialCompany.companyProvidesTransport"
          control={control}
          render={({ field: { onChange, value, onBlur }, fieldState }) => (
            <Select
              required
              data-testid="company-provides-transport-select"
              data={transformDataToSelectOption(options, "value", "label", t, "common")}
              label={t("registerCompany:transport.companyProvidesTransport")}
              onChange={(val) => onChange(val === "true")}
              value={value ? "true" : "false"}
              error={fieldState.error?.message ? t(fieldState.error.message) : undefined}
              onBlur={async () => {
                onBlur();
                await saveDraft();
              }}
            />
          )}
        />
      </Grid.Col>
    </Grid>
  );

  return <AccordionTwoColumnGrid leftContent={leftContent} rightContent={rightContent} />;
};

export default TransportResponsible;
